import styled from 'styled-components';

import {CANCELLED_KEY, COMPLETED_KEY, FAILED_KEY} from '@ibibo/myaccount-reducer';

const getStatusGradient = (status) => {
    switch(status) {
      case CANCELLED_KEY:
        return `linear-gradient(261deg, #f09819, #f3d452)`;
      case FAILED_KEY:
        return `linear-gradient(262deg, #ff3e5e, #ff7f3f)`;
      case COMPLETED_KEY:
        return `linear-gradient(262deg, #afb3ba, #cfcfcf)`;
      default:
        return `linear-gradient(260deg, #43c4a0, #3bb0c7)`;
    }
}

export const ListingHeaderOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const ListingHeaderTopBack = styled.div(
    props => `
        width: 100%;
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        height: 23rem;
    `
);

export const ListingHeadBackColor = styled.div(
    props => `
        background-image: ${getStatusGradient(props.status)};
        width:100%;
        display: flex;
        height: 23rem;
    `
);

export const ListingHeaderInfoOuterWrap = styled.div(
    props => `
        max-width:120rem;
        margin: 0 auto;
        width:100%;
        display: flex;
    `
);

export const ListingHeaderInfoInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding-top:${props.theme.spacing.large.l30};
        z-index:2;
    `
)